import api from '@js/actions/api';

export const fetchSearch = (searchParams, requestOptions = {}) => (
    api
        .get('/api/v1/search', {
            search: searchParams
        }, requestOptions)
);

export const fetchSearchRecommendation = (selectedType, limit, isHomePage = false) => (
    api
        .get('/api/v1/search/populars', {
            search: {
                selectedTypes: [selectedType],
                limit,
                homePage: isHomePage
            }
        })
);

export const fetchNearbyRecommendations = (recommendations, limit) => (
    api
        .get('/api/v1/search/recommendations', {
            search: {
                selectedTypes: 'all',
                limit
            }
        })
);
